
import React, { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Layout } from '@/components/layout/Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { PressHeroSection } from '@/components/press/PressHeroSection';
import { PressConceptSection } from '@/components/press/PressConceptSection';
import { PressCreationsSection } from '@/components/press/PressCreationsSection';
import { PressResourcesSection } from '@/components/press/PressResourcesSection';
import { PressPartnersSection } from '@/components/press/PressPartnersSection';
import { PressQuotesSection } from '@/components/press/PressQuotesSection';

export const PressRoom = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  
  // SEO configuration
  const seo = useSEO({
    title: language === 'fr' ? 'Espace Presse | Recut x StudioCanal' : 'Press Room | Recut x StudioCanal',
    description: language === 'fr' 
      ? "Le premier challenge créatif short form autour d'un film, 100 % légal et organique. Découvrez comment Recut transforme la relation entre créateurs et ayants droit."
      : "The first creative short form challenge around a film, 100% legal and organic. Discover how Recut is transforming the relationship between creators and rights holders.",
    keywords: ['presse', 'press', 'recut', 'studiocanal', 'cinema', 'creators', 'remix', 'legal'],
  });

  useEffect(() => {
    // Handle URL localization
    const correctPath = language === 'fr' ? '/espace-presse' : '/press-room';
    if (location.pathname !== correctPath) {
      navigate(correctPath, { replace: true });
    }
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, [language, location.pathname, navigate]);

  return (
    <Layout>
      <div className="min-h-screen bg-background animate-fade-in">
        {/* Hero Section */}
        <PressHeroSection />
        
        {/* Concept Section with Raw Clips */}
        <PressConceptSection />
        
        {/* Creations Section with TikTok Embeds */}
        <PressCreationsSection />
        
        {/* Press Resources Section */}
        <PressResourcesSection />
        
        {/* Partners Section */}
        <PressPartnersSection />
        
        {/* Quotes Section */}
        <PressQuotesSection />
      </div>
    </Layout>
  );
};

export default PressRoom;
